module.exports = __webpack_public_path__ + "img/scan-a.c58f7472.svg";